export function getValidItems(items, requiredItem) {
  return items.filter(item => item.enabled || item.id === requiredItem?.id)
}
